import { IAskData } from '../../Dropdown/Dropdown.types';

const subjectData: Array<IAskData> = [
  { value: '107', label: 'Английский язык' },
  { value: '125', label: 'Астрономия' },
  { value: '109', label: 'Биология' },
  { value: '111', label: 'География' },
  { value: '127', label: 'Геометрия' },
  { value: '118', label: 'Естествознание' },
  { value: '113', label: 'Информатика' },
  { value: '121', label: 'Истоки' },
  { value: '105', label: 'История' },
  { value: '124', label: 'Краеведение' },
  { value: '123', label: 'Кубановедение' },
  { value: '110', label: 'Литература' },
  { value: '116', label: 'Литературное чтение' },
  { value: '108', label: 'Математика' },
  { value: '119', label: 'Музыка' },
  { value: '126', label: 'Немецкий язык' },
  { value: '117', label: 'ОБЖ' },
  { value: '115', label: 'Обществознание' },
  { value: '104', label: 'Окружающий мир' },
  { value: '130', label: 'Право' },
  { value: '106', label: 'Природоведение' },
  { value: '120', label: 'Родной край' },
  { value: '114', label: 'Русский язык' },
  { value: '122', label: 'Технология' },
  { value: '112', label: 'Физика' },
  { value: '131', label: 'Французский язык' },
  { value: '132', label: 'Химия' },
  { value: '128', label: 'Черчение' },
  { value: '129', label: 'Экономика' },
];
const levelData: Array<IAskData> = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
];

export { subjectData, levelData };
